import { createClient } from '@supabase/supabase-js';

import { env } from '@/env';
import { Database } from '@/lib/supabase/types';

export const supabase = createClient<Database>(
  env.SUPABASE_URL,
  env.SUPABASE_KEY,
);
